import './about.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faChevronRight,
  faShieldAlt,
  faUserShield,
  faKey,
  faEraser,
  faFileExport,
  faBan,
  faBalanceScale,
  faFileAlt,
  faEnvelope
} from "@fortawesome/free-solid-svg-icons";


const GDPR = () => {
  const currentDate = new Intl.DateTimeFormat('ro-RO', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(new Date());

  return (
  
      <div className="general-container-footer-info-ab">
                 <div className="info-footer-container-ab">
           
      


                     <div className='tittle-ab-top'>
                        <h4>Protectia Datelor Personale (GDPR)</h4>
                    </div>
           
                   
           
                {/* Introducere GDPR */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faShieldAlt} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Ce este GDPR?</h4>
    <p>
      Regulamentul General privind Protectia Datelor (GDPR - General Data Protection Regulation) este o legislatie europeana 
      care protejeaza drepturile si libertatile persoanelor in ceea ce priveste prelucrarea datelor cu caracter personal.
    </p>
    <p>
      La ContaLearn, respectam pe deplin prevederile GDPR si ne angajam sa protejam datele tale personale cu cea mai mare grija.
    </p>
    <p><strong>Data aplicarii:</strong> {currentDate}</p>
  </div>
</section>


{/* Drepturile tale conform GDPR */}
<section className="section-about-2">
  <div className="part-text-about">
    <h4>Drepturile tale conform GDPR</h4>

    <p>
      In conformitate cu GDPR, ai urmatoarele
      drepturi fundamentale:
    </p>

    <ul
      style={{
        marginTop: "15px",
        listStyleType: "none",
        paddingLeft: 0
      }}
    >
      <li style={{ marginBottom: "10px" }}>
        <strong>Dreptul de acces (Art. 15 GDPR)</strong>
        {" - "}
        Poti solicita informatii despre datele
        personale pe care le prelucram.
      </li>

      <li style={{ marginBottom: "10px" }}>
        <strong>Dreptul de rectificare (Art. 16 GDPR)</strong>
        {" - "}
        Poti solicita corectarea datelor inexacte
        sau completarea celor incomplete.
      </li>

      <li style={{ marginBottom: "10px" }}>
        <strong>Dreptul la stergerea datelor (Art. 17 GDPR)</strong>
        {" - "}
        Poti solicita stergerea datelor tale
        personale in conditiile prevazute de GDPR.
      </li>

      <li style={{ marginBottom: "10px" }}>
        <strong>
          Dreptul la restrictionarea prelucrarii
          (Art. 18 GDPR)
        </strong>
        {" - "}
        Poti solicita limitarea prelucrarii
        datelor tale in anumite situatii.
      </li>

      <li style={{ marginBottom: "10px" }}>
        <strong>
          Dreptul la portabilitatea datelor
          (Art. 20 GDPR)
        </strong>
        {" - "}
        In conditiile prevazute de GDPR, poti primi
        datele personale care te privesc intr-un
        format structurat si utilizat in mod curent.
      </li>

      <li style={{ marginBottom: "10px" }}>
        <strong>
          Dreptul de opozitie (Art. 21 GDPR)
        </strong>
        {" - "}
        Te poti opune prelucrarii datelor personale
        in conditiile prevazute de GDPR.
      </li>

      <li style={{ marginBottom: "10px" }}>
        <strong>
          Drepturi privind deciziile automate
          (Art. 22 GDPR)
        </strong>
        {" - "}
        Beneficiezi de protectie in cazul anumitor
        decizii bazate exclusiv pe prelucrare
        automata, inclusiv profilare.
      </li>
    </ul>
  </div>

  <div className="part-image-about">
    <FontAwesomeIcon
      icon={faUserShield}
      className="icon-about-large"
      style={{
        fontSize: "120px",
        color: "#13b8ab"
      }}
    />
  </div>
</section>


{/* Dreptul de acces */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faKey} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Dreptul de acces la date (Art. 15 GDPR)</h4>
    <p>
      Ai dreptul sa obtii de la ContaLearn o confirmare ca prelucram sau nu date cu caracter personal care te privesc 
      si, in caz afirmativ, acces la acestea.
    </p>
    <p><strong>Ce poti solicita:</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>▸ O copie a datelor personale</li>
      <li>▸ Scopurile prelucrarii</li>
      <li>▸ Categoriile de date prelucrate</li>
      <li>▸ Destinatarii datelor tale</li>
      <li>▸ Perioada de stocare a datelor</li>
      <li>▸ Existenta drepturilor GDPR</li>
    </ul>
    <p><strong>Termen de raspuns:</strong> Maximum 30 zile de la solicitare</p>
  </div>
</section>

{/* Dreptul la stergere */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Dreptul la stergerea datelor - "Dreptul de a fi uitat" (Art. 17 GDPR)</h4>
    <p>
      Poti solicita stergerea datelor tale personale in urmatoarele situatii:
    </p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>✓ Datele nu mai sunt necesare pentru scopurile pentru care au fost colectate</li>
      <li>✓ Iti retragi consimtamantul si nu exista alt temei legal pentru prelucrare</li>
      <li>✓ Te opui prelucrarii si nu exista motive legitime care sa prevaleze</li>
      <li>✓ Datele au fost prelucrate ilegal</li>
      <li>✓ Datele trebuie sterse pentru respectarea unei obligatii legale</li>
    </ul>
    <p><strong>Exceptii:</strong> Nu putem sterge datele daca prelucrarea este necesara pentru:</p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>▸ Respectarea unei obligatii legale</li>
      <li>▸ Constatarea, exercitarea sau apararea unui drept in instanta</li>
      <li>▸ Motive de interes public in domeniul sanatatii publice</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faEraser} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Dreptul la portabilitate */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faFileExport} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Dreptul la portabilitatea datelor (Art. 20 GDPR)</h4>
    <p>
      Ai dreptul sa primesti datele personale pe care ni le-ai furnizat intr-un format structurat, utilizat in mod curent 
      si care poate fi citit automat (de exemplu: JSON, CSV, XML).
    </p>
    <p><strong>Ce include:</strong></p>
    <ul style={{listStyleType: 'none', paddingLeft: 0}}>
      <li>▸ Datele pe care le-ai furnizat direct (nume, email, etc.)</li>
      <li>▸ Datele generate prin utilizarea platformei (progres, raspunsuri, rezultate)</li>
    </ul>
    <p>
      De asemenea, poti solicita transmiterea directa a acestor date catre alt operator, unde este posibil din punct de vedere tehnic.
    </p>
  </div>
</section>

{/* Dreptul de opozitie */}
<section className='section-about-2'>
  <div className='part-text-about'>
    <h4>Dreptul de opozitie (Art. 21 GDPR)</h4>
    <p>
      Te poti opune oricand, din motive legate de situatia ta particulara, ca datele tale sa fie prelucrate pe baza:
    </p>
    <ul>
      <li>▸ Interesului legitim al ContaLearn (Art. 6(1)(f) GDPR)</li>
      <li>▸ Interesului public (Art. 6(1)(e) GDPR)</li>
    </ul>
    <p><strong>Marketing direct:</strong></p>
    <p>
      Te poti opozi oricand si neconditionat prelucrarii datelor tale in scopuri de marketing direct. 
      In acest caz, vom inceta imediat prelucrarea pentru aceste scopuri.
    </p>
    <p><strong>Cum te poti opune:</strong></p>
    <ul>
      <li>▸ Prin setarile contului tau</li>
      <li>▸ Prin click pe "Dezabonare" din email-urile noastre</li>
      <li>▸ Prin solicitare la contact@contalearn.ro</li>
    </ul>
  </div>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBan} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
</section>

{/* Baze legale */}
<section className='section-about-2'>
  <div className='part-image-about'>
    <FontAwesomeIcon icon={faBalanceScale} className='icon-about-large' style={{fontSize: '120px', color: '#13b8ab'}} />
  </div>
  <div className='part-text-about'>
    <h4>Bazele legale ale prelucrarii (Art. 6 GDPR)</h4>
    <p>
      Prelucram datele tale personale numai pe baze legale conforme GDPR:
    </p>
    <ul style={{marginTop: '15px', listStyleType: 'none', paddingLeft: 0}}>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(a) - Consimtamant</strong><br />
        Ai dat consimtamantul pentru prelucrarea datelor (ex: newsletter, marketing)
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(b) - Executarea contractului</strong><br />
        Prelucrarea este necesara pentru executarea contractului (ex: furnizarea cursurilor)
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(c) - Obligatie legala</strong><br />
        Prelucrarea este necesara pentru respectarea unei obligatii legale (ex: evidenta contabila)
      </li>
      <li style={{marginBottom: '10px'}}>
        <strong>Art. 6(1)(f) - Interes legitim</strong><br />
        Prelucrarea este necesara pentru un interes legitim (ex: prevenirea fraudelor, imbunatatirea platformei)
      </li>
    </ul>
  </div>
</section>





           
           
           
                 
           
                 </div>
               </div>
   
  );
};

export default GDPR;

